import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import GlobalUpdateIndicator from '../ui/GlobalUpdateIndicator';

const MainLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50 relative">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden lg:ml-0 relative">
        {/* Header */}
        <Header onToggleSidebar={toggleSidebar} />

        {/* Global Update Indicator */}
        <GlobalUpdateIndicator />

        {/* Page Content */}
        <main className="flex-1 overflow-auto scrollbar-hide relative">
          <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 lg:px-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
